module.exports = __webpack_public_path__ + "img/alpine-radio.ff9b8459.png";